let scrollPosition = 0;
let body;
// const DISABLE_SCROLLING_CLASS = 'scroll-disabled';

export default {
  enable() {
    scrollPosition = window.pageYOffset;
    body = document.querySelector('body');
    body.classList.add('scroll-disabled');
    body.style.top = `-${scrollPosition}px`;
  },
  disable() {
    if (!body) {
      return;
    }

    body.classList.remove('scroll-disabled');
    body.style.removeProperty('top');

    window.scrollTo(0, scrollPosition);
  },
};